import { useLocation, useNavigate } from "react-router-dom";
import drSanjeevani from "@/assets/dr-sanjeevani.png";

// Global floating Dr Sanjeevani assistant button (mirrors mobile FloatingAIAssistant).
// Hidden on the chat screen itself. Fixed bottom-right, sits above the mobile bottom nav.
const HIDE_ON = ["/assistant"];

export default function FloatingDrSanjeevani() {
  const location = useLocation();
  const navigate = useNavigate();
  if (HIDE_ON.some((p) => location.pathname.startsWith(p))) return null;

  return (
    <button
      onClick={() => navigate("/assistant")}
      data-testid="floating-dr-sanjeevani"
      aria-label="Ask Dr Sanjeevani — AI Health Assistant"
      className="fixed z-40 bottom-24 right-4 md:bottom-8 md:right-8 h-14 w-14 rounded-full bg-white shadow-lg flex items-center justify-center overflow-hidden ring-1 ring-black/5 transition-transform hover:scale-105 active:scale-95"
    >
      <span className="absolute inset-0 rounded-full animate-ping bg-[#2E7D32]/30" />
      <img src={drSanjeevani} alt="Dr Sanjeevani" className="relative h-14 w-14 object-contain" />
      <span className="absolute top-1.5 right-1.5 h-2.5 w-2.5 rounded-full bg-[#4CAF50] border-2 border-white" />
    </button>
  );
}
